var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#ECEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 35.3332C48.5444 35.3332 44.6776 36.5061 41.3886 38.7038C38.0996 40.9014 35.5362 44.025 34.0224 47.6795C32.5087 51.334 32.1126 55.3554 32.8843 59.235C33.656 63.1146 35.5608 66.6782 38.3579 69.4753C41.1549 72.2724 44.7186 74.1772 48.5982 74.9489C52.4778 75.7206 56.4992 75.3245 60.1537 73.8108C63.8082 72.297 66.9318 69.7336 69.1294 66.4446C71.327 63.1556 72.5 59.2888 72.5 55.3332C72.4939 50.0307 70.3848 44.9471 66.6354 41.1977C62.886 37.4483 57.8025 35.3392 52.5 35.3332ZM62.0125 48.179L53.6792 56.5123C53.5243 56.6672 53.3405 56.79 53.1382 56.8738C52.9358 56.9576 52.719 57.0008 52.5 57.0008C52.281 57.0008 52.0642 56.9576 51.8618 56.8738C51.6595 56.79 51.4757 56.6672 51.3208 56.5123C51.166 56.3575 51.0432 56.1736 50.9593 55.9713C50.8755 55.769 50.8324 55.5522 50.8324 55.3332C50.8324 55.1142 50.8755 54.8973 50.9593 54.695C51.0432 54.4927 51.166 54.3088 51.3208 54.154L59.6542 45.8207C59.809 45.6658 59.9929 45.543 60.1952 45.4592C60.3975 45.3754 60.6143 45.3322 60.8333 45.3322C61.0523 45.3322 61.2692 45.3754 61.4715 45.4592C61.6738 45.543 61.8577 45.6658 62.0125 45.8207C62.1674 45.9755 62.2902 46.1594 62.374 46.3617C62.4578 46.564 62.5009 46.7808 62.5009 46.9998C62.5009 47.2188 62.4578 47.4357 62.374 47.638C62.2902 47.8403 62.1674 48.0242 62.0125 48.179ZM45.8333 30.3332C45.8333 29.8911 46.0089 29.4672 46.3215 29.1547C46.6341 28.8421 47.058 28.6665 47.5 28.6665H57.5C57.942 28.6665 58.366 28.8421 58.6785 29.1547C58.9911 29.4672 59.1667 29.8911 59.1667 30.3332C59.1667 30.7752 58.9911 31.1991 58.6785 31.5117C58.366 31.8242 57.942 31.9998 57.5 31.9998H47.5C47.058 31.9998 46.6341 31.8242 46.3215 31.5117C46.0089 31.1991 45.8333 30.7752 45.8333 30.3332Z",
    fill: "#4453C5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f3dbc04945535a4708d983176faa3dbe.svg";
export { ForwardRef as ReactComponent };